// REACT
import React from "react";

// MATERIAL-UI
import { Typography, Button } from "@mui/material";

// ASSETS
import { HoldingModalStyles } from "src/components/wallets/common/styles/HoldingModal.styles";

interface ConfirmButtonProps {
  title: string;
  height?: number;
  has2FA?: boolean;
  onClick?: (event: any) => void;
  sx?: any;
  // onClose?: (event: any) => void;
}

const ConfirmButton = (props: ConfirmButtonProps) => {
  const { height, title, sx } = props;
  const classes = HoldingModalStyles();

  return (
    <Button
      disableRipple
      fullWidth
      className={classes.transactionButton}
      style={{ height: height }}
      color="secondary"
      variant="contained"
      type="submit"
      onClick={props.onClick}
      disabled={!props.has2FA}
      {...sx}>
      <Typography className={classes.transactionButtonText}>{title}</Typography>
    </Button>
  );
};

export default ConfirmButton;
